// extracted by mini-css-extract-plugin
export default {"contain":"AuthCallbackForm_contain__Wn6O1","card":"AuthCallbackForm_card__ASWyW","field":"AuthCallbackForm_field__Uxqgp"};